import React from "react";
import { motion } from "framer-motion";
import { MapPin, Clock } from "lucide-react";

export default function Cities({ cities, content }) {
  const live = cities.filter((c) => c.is_active);
  const soon = cities.filter((c) => !c.is_active);

  return (
    <section id="cities" className="section">
      <div className="container-z grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <div className="label-mono mb-3">Where we operate</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#1A231E]">
            Currently <span className="text-[#C86646]">live</span> in Pune.
            <br />
            Expanding across India.
          </h2>
          <p className="mt-4 text-base text-[#5C6B62] max-w-lg">
            We're starting with the cities our users asked for the most — and rolling out to new
            metros every quarter.
          </p>

          <div className="mt-7 space-y-3">
            {live.map((c) => (
              <motion.div
                key={c.id}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4 }}
                className="flex items-center gap-3 p-4 rounded-2xl bg-[#EAF1ED] border border-[#C8DDD2]"
                data-testid={`city-live-${c.name.toLowerCase()}`}
              >
                <MapPin className="w-5 h-5 text-[#1E3F33]" />
                <span className="font-semibold text-[#1A231E]">{c.name}</span>
                <span className="ml-auto text-xs font-bold uppercase tracking-wider text-[#1E3F33] bg-white px-2.5 py-1 rounded-full">
                  Live
                </span>
              </motion.div>
            ))}
            {soon.map((c) => (
              <motion.div
                key={c.id}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4 }}
                className="flex items-center gap-3 p-4 rounded-2xl bg-white border border-[#E4E1D9]"
                data-testid={`city-soon-${c.name.toLowerCase()}`}
              >
                <Clock className="w-5 h-5 text-[#5C6B62]" />
                <span className="font-semibold text-[#1A231E]">{c.name}</span>
                <span className="ml-auto text-xs font-bold uppercase tracking-wider text-[#5C6B62] bg-[#F7F6F2] px-2.5 py-1 rounded-full">
                  Coming Soon
                </span>
              </motion.div>
            ))}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative"
        >
          <div className="zcard overflow-hidden">
            <div
              className="aspect-[4/5] bg-cover bg-center"
              style={{ backgroundImage: `url(${content.city_image_url})` }}
            />
            <div className="p-5 sm:p-6">
              <div className="text-xs label-mono mb-1" style={{ color: "#C86646" }}>Coverage map</div>
              <div className="text-lg font-bold text-[#1A231E]">
                {live.length} city live · {soon.length} launching soon
              </div>
              <div className="text-sm text-[#5C6B62] mt-1">
                Want Zumroo in your city? Tell us in the contact form below.
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
